import I18n from 'lib/i18n/i18n';
import echarts from 'echarts';

export function getOption(props){
    const carat = props.carat;
    const certificates = ['GIA', 'IGI', 'GSI', 'EGL', 'Other'];
    let data = [];
    let value = carat >= 0.8 ? 'high':'low';
    certificates.map(cert => {
        let percent = I18n.getString(`itemPage::trends::gradingCertificates::${value}Carat::${cert}`);
        data.push(percent);
    })
    const most = I18n.getString('itemPage::trends::gradingCertificates::most');
    const least = I18n.getString('itemPage::trends::gradingCertificates::least');
    const trusted = I18n.getString('itemPage::trends::gradingCertificates::trusted');
    let option = {
        grid: {
            left: '17%',
            right:'5%',
            bottom: '20',
            top: '30%'
        },
        dataZoom:{
            type:'inside',
            disabled: true
        },
        xAxis: [{
                type : 'category',
                data : certificates,
                axisTick: {
                    alignWithLabel: true,
                    show: false  
                },
                axisLine:{
                    show: false
                },
                axisLabel:{
                    fontWeight: 400,
                    fontSize: 14,
                    color: '#141414'
                }
            }],
        yAxis: [{
                type: 'value',
                axisLabel: {
                    formatter: '{value}%',
                    color: '#bcbcbc',
                    fontSize: 13.5,
                    fontWeight: 400
                },
                axisLine:{
                    show: false
                },
                axisTick:{
                    show: false  
                },
                offset: 10,
                splitLine:{
                    lineStyle:{
                        color: '#eeeeee'
                    }
                }
            }],
        series: [{
                type: 'bar',
                barWidth: '25%',
                data: data,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: I18n.getString('itemPage::trends::gradingCertificates::lightColor')
                }, {
                    offset: 1,
                    color: I18n.getString('itemPage::trends::gradingCertificates::darkColor')
                }]),
                markPoint: {
                    symbolSize: 1,
                    symbolOffset: [0, '50%'],
                    label: {
                        normal: {
                            color: '#646464',
                            formatter: `{a|{b}}\n{b|${trusted}}`,
                            backgroundColor: 'white',
                            padding: [5, 15, 8, 15],
                            position: 'top',
                            distance: 15,
                            shadowBlur: 6,
                            shadowOffsetX: 1,
                            shadowOffsetY: 1,
                            shadowColor: 'rgba(136, 135, 135, 0.5)',
                            fontSize: 14,
                            fontWeight: 400,
                            rich:{
                                a:{
                                    fontSize: 14,
                                    color: '#646464',
                                    fontWeight: 200,
                                    align:'center',
                                    lineHeight: 25
                                },
                                b:{
                                    fontSize: 14,
                                    color: '#646464',
                                    fontWeight: 200,
                                    align:'center'
                                }
                            }
                        }
                    },
                    data: [
                        {type: 'max', name: most},
                        {type: 'min', name: least}
                    ]
                }
            }]
    };
    return option;
}